module.exports = __webpack_public_path__ + "static/media/manage-product.c4c945eb.svg";